const dominio = "http://sim3.cpe.gov.co";
const version = "/rest/v1.0";
import store from "./store";

console.log("Conectado a: ", dominio);

// alert(store.getters.slug)

// Objeto con las rutas del api
const rutas = {
  detallePreinscripcion: `${dominio}${version}/preinscripciondetalle/`, // GET
  consultarCedula: `${dominio}${version}/preinscripcion/formacion/:{estrategia}/`, // POST
  diplomadosDisponibles: `${dominio}${version}/preinscripcion/formacion/:{estrategia}/diplomados/`,
  preInscribir: `${dominio}${version}/preinscripcion/formacion/:{estrategia}/preinscribir/`,
  departamentos: `${dominio}${version}/departamentos/`,
  municipiosDepartamento: `${dominio}${version}/departamentos/:{departamentoId}/`,
  municipios: `${dominio}${version}/municipios/`,
  detalleMunicipio: `${dominio}${version}/municipios/:{municipioId}`,
  sedesMunicipio: `${dominio}${version}/radicados/:{municipioId}`,
  generos: `${dominio}${version}/generos/`,
  tiposDocumento: `${dominio}${version}/tipos_documento/`,
  cargos: `${dominio}${version}/docentes/cargos/`,
  actaNombramiento: `${dominio}${version}/preinscripcion/formacion/:{estrategia}/acta_nombramiento/`, // POST
  camposAdicionales: `${dominio}${version}/preinscripcion/formacion/:{estrategia}/campos_adicionales/`
};

// Exportar rutas individualmente como un string
export const detallePreinscripcion = rutas.detallePreinscripcion;
export const consultarCedula = () =>
  rutas.consultarCedula.replace(":{estrategia}", store.getters.estrategia);
export const diplomadosDisponibles = () =>
  rutas.diplomadosDisponibles.replace(
    ":{estrategia}",
    store.getters.estrategia
  );
export const camposAdicionales = () =>
  rutas.camposAdicionales.replace(":{estrategia}", store.getters.estrategia);
export const preInscribir = () =>
  rutas.preInscribir.replace(":{estrategia}", store.getters.estrategia);
export const actaNombramiento = () =>
  rutas.actaNombramiento.replace(":{estrategia}", store.getters.estrategia);
export const departamentos = rutas.departamentos;
export const municipios = rutas.municipios;
export const generos = rutas.generos;
export const tiposDocumento = rutas.tiposDocumento;
export const cargos = rutas.cargos;
export const municipiosDepartamento = departamentoId =>
  rutas.municipiosDepartamento.replace(":{departamentoId}", departamentoId);
export const detalleMunicipio = municipioId =>
  rutas.detalleMunicipio.replace(":{municipioId}", municipioId);
export const sedesMunicipio = municipioId =>
  rutas.sedesMunicipio.replace(":{municipioId}", municipioId);

export default rutas;
